export const setScreenType = (screenType) => ({
    type: 'SET_DEVICE_TYPE',
    payload: screenType,
});
